import React from "react";
import {
  VertRadioSelectBox,
  VertSelect,
  VertTypography,
} from "@vertem-core/vertice-ds";
import { sortByKey } from "Utils/sort";

const ProductDetailFeatures = ({
  featuresItems,
  onClickFeature,
  selectedsFeatures,
}) => {
  return (
    <>
      {(Object.keys(featuresItems || {}) || []).map((key) => {
        if (!featuresItems[key]) return null;

        const sortedItems = featuresItems[key].sort(sortByKey("label"));

        return (
          <div key={key}>
            <div className="divider" />
            {(() => {
              switch (key) {
                case "COR":
                  return (
                    <div className="color-select-option">
                      <VertTypography.Paragraph className="option-input-label">
                        Selecione uma cor
                      </VertTypography.Paragraph>
                      <VertSelect
                        items={sortedItems}
                        placeholder="Selecionar"
                        template="marketplace"
                        onChange={(value) => onClickFeature(key, value)}
                        value={selectedsFeatures[key]}
                      />
                    </div>
                  );
                case "VOLTAGEM":
                  return (
                    <VertRadioSelectBox
                      items={sortedItems}
                      label={key}
                      template="marketplace"
                      selectHandler={(value) => onClickFeature(key, value)}
                      selectedItem={selectedsFeatures[key]}
                    />
                  );
                default:
                  return (
                    <div className="color-select-option">
                      <VertTypography.Paragraph className="option-input-label">
                        {key}
                      </VertTypography.Paragraph>
                      <VertSelect
                        items={sortedItems}
                        placeholder="Selecionar"
                        template="marketplace"
                        onChange={(value) => onClickFeature(key, value)}
                        value={selectedsFeatures[key]}
                      />
                    </div>
                  );
              }
            })()}
          </div>
        );
      })}
    </>
  );
};

export default ProductDetailFeatures;
